import { createContext } from 'react';

export const ObjectDetectRefContext = createContext({
    // tts
    speaker: {},
    setSpeaker: () => {},
    browserVoiceList: [],
    setBrowserVocieList: () => {},
    currentVoice: [],
    setCurrentVoice: () => {},
    currentLang: [],
    setCurrentLang: ()=> {},
    // 2021-06-28
    cocoDataSetTts: [],
    setCocoDataSetTts: () => {}
})